// src/v3/enums/ringFinish.ts
var RingFinishEnum = /* @__PURE__ */ ((RingFinishEnum2) => {
  RingFinishEnum2["Silver"] = "silver";
  RingFinishEnum2["Black"] = "black";
  RingFinishEnum2["BrushedSilver"] = "brushed-silver";
  RingFinishEnum2["Stealth"] = "stealth";
  RingFinishEnum2["Titanium"] = "titanium";
  RingFinishEnum2["Gold"] = "gold";
  RingFinishEnum2["Rose"] = "rose";
  RingFinishEnum2["RoseGold"] = "rose-gold";
  RingFinishEnum2["Midnight"] = "midnight";
  RingFinishEnum2["Tide"] = "tide";
  RingFinishEnum2["Petal"] = "petal";
  RingFinishEnum2["Cloud"] = "cloud";
  return RingFinishEnum2;
})(RingFinishEnum || {});
export {
  RingFinishEnum
};
//# sourceMappingURL=ringFinish.mjs.map